import React from 'react';
import PropTypes from 'prop-types';

function Loading({ isLoading, pastDelay, error }) {
  if (isLoading && pastDelay) {
    return <p>Loading...</p>;
  } else if (error && !isLoading) {
    return <p>Error!</p>;
  } else {
    return null;
  }
}

Loading.propTypes = {
  error: PropTypes.string,
  isLoading: PropTypes.bool,
  pastDelay: PropTypes.bool
};

export default Loading;



// WEBPACK FOOTER //
// ./src/components/pages/LazyLoadComponentExamplePage/Loading.js